import type { Variants } from "framer-motion";

/**
 * Marketing motion vocabulary. design.md §12 requires every public marketing
 * section to animate on scroll with a *shared* ease and duration — new sections
 * MUST match these values rather than inventing a per-section register. This is
 * the single source of that vocabulary: a refined, editorial register built
 * from a soft fade and a short rise.
 */

/** Editorial ease-out curve (cubic-bézier). Soft, unhurried settle. */
export const EASE_EDITORIAL: [number, number, number, number] = [0.22, 1, 0.36, 1];

/** Duration, in seconds, of a single element's reveal. */
export const REVEAL_DURATION = 0.8;

/** Delay, in seconds, between successive children in a staggered group. */
export const STAGGER_GAP = 0.1;

/**
 * Shared scroll trigger: animate once. The negative bottom `margin` pulls the
 * trigger line up from the viewport's bottom edge (~20% of viewport height), so
 * sections reveal once they're meaningfully in view rather than the instant they
 * peek above the fold. `amount` then requires a small fraction of the element to
 * be within that adjusted band.
 */
export const VIEWPORT = {
  once: true,
  amount: 0.3,
  margin: "0px 0px -20% 0px",
} as const;

/** Fade + short rise. The atom every marketing reveal is built from. */
export const fadeRise: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: REVEAL_DURATION, ease: EASE_EDITORIAL },
  },
};

/** Orchestrates child <StaggerItem>s into a sequence. */
export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: STAGGER_GAP } },
};
